import { PayModifierCategory } from '@amzn/atoz-shiftapp-types';
// TODO: Replace with generated GQL types when available
var PayCategory;
(function (PayCategory) {
    PayCategory["Base"] = "BASE";
    PayCategory["ShiftDifferential"] = "SHIFT_DIFFERENTIAL";
    PayCategory["HighDemandPremium"] = "HIGH_DEMAND_PREMIUM";
    PayCategory["NightAndWeekendPremium"] = "NIGHT_AND_WEEKEND_PREMIUM";
    PayCategory["PeakHiringPremium"] = "PEAK_HIRING_PREMIUM";
})(PayCategory || (PayCategory = {}));
export var isSurgePay = function (payCategories) {
    if (!payCategories) {
        return false;
    }
    return payCategories.some(function (payCategory) {
        return payCategory.category === PayModifierCategory.HighDemandPremium;
    });
};
